import { ResponseBaseDTO } from './responseBaseDTO';
import { DoorStatus } from '../model/doorStatus';

export class StatusResponseDTO extends ResponseBaseDTO {
    public doors: DoorStatus[];
}



// WEBPACK FOOTER //
// ./src/app/DTO/statusResponseDTO.ts